import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/minimaleeisenperinfrastructuur/";

const MinimaleEisenPerInfrastructuurApi = {
	get(infrastructuurId) {
		const serviceUrl = prependRoot(routePrefix + infrastructuurId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	save(minimaleEisenPerInfrastructuur, documenten) {
		const serviceUrl = prependRoot(routePrefix, getApiRoot());
		return axios.put(serviceUrl, {
			item: minimaleEisenPerInfrastructuur,
			documenten
		},
			{
				headers: {
					'accept': 'application/json'
				}
			});
	}
};

export default MinimaleEisenPerInfrastructuurApi;
